module.exports = __webpack_public_path__ + "img/TL.06957392.svg";